import { CONST } from "../CONST";
import { MinigameScene } from "./generic/MinigameScene";

export class GrandchildrenScene extends MinigameScene {
    //Images
    private audio !: Phaser.Sound.BaseSound;

    //values
    private moveSpeed = 107;
    private deathDistance = 10;
    private scaleMultiplier = 0.0115;
    private legScaleMultiplier = 2.175;

    private kidConfig = [
        {
        spawnPos: {x: 594, y: 258}, 
        targetPos: {x: 219, y: 208}, 
        image: CONST.GRANDCHILDREN.KID1, 
        legOffset: {x: 4, y: 8},
        electric: true
        },

       {
        spawnPos: {x: 246, y: 278}, 
        targetPos: {x: 747, y: 303}, 
        image: CONST.GRANDCHILDREN.KID2, 
        legOffset: {x: 4, y: 8},
        electric: false
       },

        {
        spawnPos: {x: 766, y: 389}, 
        targetPos: {x: 182, y: 352}, 
        image: CONST.GRANDCHILDREN.KID3, 
        legOffset: {x: 4, y: 16},
        electric: false
        }
    ];

    private walls = [
        {k: 1, n: -440},
        {k: 0, n: 200},
        {k: -1, n: 434},
    ]

    //logic vars
    private kids = [];

    constructor(){
        super ({
            sceneName: CONST.SCENES.GRANDCHILDREN,
            duration: 13000,
            startScreenColor: 0xC5C5C5,
            startText: "GRAND\nCHILDREN!",
            startTextYOrigin: 0.35,
            startTextColor: 0x111111,
            endScreen: CONST.GRANDCHILDREN.END,
            nextScene: CONST.SCENES.PILLS,
            endButtons: {
                normalNoSkip: {x: 426.5, y: 75, scale: 1.30},
                normalWithSkip: {x: 283, y: 75, scale: 1.30},
                skip: {x: 570, y: 75, scale: 1.30}
            }
          })
    }
    _init(){
        //Reset all class variables that change during scene here (including arrays that initialize in create!)
        this.kids = [];
    }

    _preload(){
    }

    _create(){
        this.add.image(0,0, CONST.GRANDCHILDREN.BACKGROUND).setOrigin(0, 0).setDepth(0);
        this.add.image(358, 73, CONST.GRANDCHILDREN.DRAGTEXT).setScale(0.78, 0.78).setDepth(1);
        this.addGrandpa();

        this.spawnKids();

        this.audio = this.sound.add(CONST.AUDIO.NOOO, {
            loop: false
        });
    }

    private addGrandpa(){
        this.addAnimation(CONST.GRANDCHILDREN.GRANDPA, CONST.ANIMATIONS.GRANDPAMOVE, 60).setDepth(10).setLoop(true).start();
        this.addAnimation(CONST.GRANDCHILDREN.HANDS_LEFT, CONST.ANIMATIONS.GRANDPALEFTHAND, 60).setDepth(11).setLoop(true).start();
        this.addAnimation(CONST.GRANDCHILDREN.HANDS_RIGHT, CONST.ANIMATIONS.GRANDPARIGHTHAND, 60).setDepth(11).setLoop(true).start();
    }

    private spawnKids(){
        this.kidConfig.forEach(config => {
            var kid = this.createKidAnim(config.image, CONST.ANIMATIONS.KIDTORSO, config.spawnPos, {x: 0, y: 0}, 12)
                        .setDraggable(this.input);
            kid.rightLeg = this.createKidAnim(CONST.MIDLIFE.FEET, CONST.ANIMATIONS.KIDRIGHTLEG, config.spawnPos, config.legOffset, 11)
                        .setScaleMultiplier(1, 2.175);
            kid.leftLeg = this.createKidAnim(CONST.MIDLIFE.FEET, CONST.ANIMATIONS.KIDLEFTLEG, config.spawnPos, config.legOffset, 11)
                        .setScaleMultiplier(1, 2.175);

            kid.leftLegOffset = kid.leftLeg.GetOffset();
            kid.rightLegOffset = kid.rightLeg.GetOffset();

            kid.config = config;
            kid.isAlive = true;
            kid.isDragging = false;

            kid.getMoveVector = (distance: number) => {
                var vec = {x: kid.config.targetPos.x - kid.GetPositionOverride().x, y: kid.config.targetPos.y - kid.GetPositionOverride().y};
                var mag = Math.sqrt(vec.x*vec.x + vec.y*vec.y);
                return {x: distance * vec.x/mag, y: distance * vec.y/mag, mag: mag};
            }

            kid.setPos = (x, y) => {
                var maxY = this.getMaxYWalls(x, y);
                kid.setPositionOverride(x, maxY);
                kid.rightLeg.setPositionOverride(x, maxY);
                kid.leftLeg.setPositionOverride(x, maxY);
            };

            kid.checkForDeath = (distance: number) => {
                if (distance < this.deathDistance){
                    kid.kill();
                }
            };
            
            kid.kill = () => {
                kid.isAlive = false;
                this.triggerLose();

                kid.setLoop(kid.config.electric).setAnimation(this.cache.json.get(kid.config.electric ? CONST.ANIMATIONS.KIDDIEELECTRIC : CONST.ANIMATIONS.KIDDIEFIRE));
            };

            kid.onUpdate = (delta: number) => {
                if (kid.isAlive){
                    var moveVector = kid.getMoveVector(this.moveSpeed * delta / 1000);
                    if (!kid.isDragging){
                        kid.setPos(kid.GetPositionOverride().x + moveVector.x, kid.GetPositionOverride().y + moveVector.y);
                    }
                    kid.checkForDeath(moveVector.mag);
                }

                kid.updateScale();
            };

            kid.updateScale = () => {
                var scMul = this.scaleMultiplier * Math.pow(Math.abs(this.getUnityY(kid.GetPositionOverride().y) - 10), 2);
                kid.setScaleMultiplier(scMul);
                kid.leftLeg.setScaleMultiplier(scMul, scMul * this.legScaleMultiplier);
                kid.rightLeg.setScaleMultiplier(scMul, scMul * this.legScaleMultiplier);

                //adjust leg offset so it is visible when scale changes
                kid.leftLeg.setOffset(kid.leftLegOffset.x, kid.leftLegOffset.y - 50 * (1 - scMul));
                kid.rightLeg.setOffset(kid.rightLegOffset.x, kid.rightLegOffset.y - 50 * (1 - scMul));

                //adjust depth
                var newDepth = kid.GetPositionOverride().y;
                kid.setDepth(newDepth);
                kid.leftLeg.setDepth(newDepth-1);
                kid.rightLeg.setDepth(newDepth-1);
            }

            this.kids.push(kid);
        });

        this.input.on('drag', function (pointer, gameObject, dragX, dragY) {
            gameObject.animation.setPos(dragX, dragY);
        }, this);

        this.input.on('dragstart', function (pointer, gameObject) {
            gameObject.animation.isDragging = true;
        }, this);

        this.input.on('dragend', function(pointer, gameObject, dropped){
            gameObject.animation.isDragging = false;
        }, this);
    }

    private createKidAnim(image, animJson, spawnPos, offset, depth){
       return this.addAnimation(image, animJson, 60)
            .setDepth(depth)
            .setLoop(true)
            .setOffset(-594 + offset.x, -258 + offset.y)
            .setPositionOverride(spawnPos.x, spawnPos.y)
            .start();
    }

    //Find max position within walls
    private getMaxYWalls(x: number, y: number) : number {
        var yMax = y;
        for (let wall of this.walls){
            var wallY = wall.k * x + wall.n;
            if (wallY > yMax){
                yMax = wallY
            }
        }
        return yMax;
    }

    _update(time: number, delta: number){
        if (!this.isCurrentState(CONST.GAMESTATE.PLAYING)) return;
        this.kids.forEach(kid => kid.onUpdate(delta));
    }

    _timeout(){
        this.triggerWin();
    }

    _afterLoss(){
    }

    _afterWin(){
    }

    private triggerLose(){
        this.audio.play();
        this.loseGame(1000);
    }

    private triggerWin(){
        //trigger win after 1 second and load next scene
        this.winGame(1000);
    }
}
